import utils from "@/api/utils";

class Import {
  constructor(api) {
    this.api = api;
  }

  getAll(timestamp, queryParams, filters, onSuccess, onError) {
    let params = "";
    if (queryParams) {
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }
    let url = "";

    if (queryParams && queryParams.import_type) {
      url = `v1/imports${params}`
    } else {
      url = `v1/imports${params}&filter[state]=${filters.state}`;
      if(!filters.state){
        url = `v1/imports?paginate=false`;
      }
    }

    return this.api.http_fibercloud
      .get(url, {
        headers: {
          Timestamp_server: timestamp
        }
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getByUUID(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/imports/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteByUUID(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/imports/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  byEndpoint(endpoint, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/" + endpoint + "/import", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  validationByEndpoint(endpoint, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/" + endpoint + "/import/upload", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getConflicts(queryParams, endpoint, uuid, onSuccess, onError) {
    let params = "";
    if (queryParams) {
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }

    return this.api.http_fibercloud
      .get("v1/" + endpoint + "/import/" + uuid + "/conflicts" + params)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getNewObjects(endpoint, uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/" + endpoint + "/import/" + uuid + "/new")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getImportObjectsPaginated(url, onSuccess, onError) {
    return this.api.http_fibercloud_complete_request
      .get(url.request)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getMapperTemplatesByLayer(layer, onSuccess, onError) {
    return this.api.http_fibercloud
      .get(
        "v1/imports/importDataMapper/templatetype/" +
          layer +
          "?include=templates"
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getMapperTemplates( queryParams,  onSuccess, onError) {
    let extras = utils.getPreparedExtras(null, null,);
    if (extras !== "") {
      extras = "&" + extras;
    }
    let params = "";
    if (queryParams) {
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }
    return this.api.http_fibercloud
      .get("v1/importDataMapper" + params + extras)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAllMapperTemplates(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/importDataMapper?paginate=false")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getMapperTemplateById(id, append, onSuccess, onError) {
    let extras = utils.getPreparedExtras(null, null, append);
    if (extras !== "") {
      extras = "?" + extras;
    }
    return this.api.http_fibercloud
      .get("v1/importDataMapper/" + id + extras)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteMapperTemplateByID(id, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/imports/importDataMapper/template/" + id)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  cancelImport(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/imports/", [{ uuid: uuid, canceled: true }])
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  cancelImportInProgress(uuid, onSuccess, onError) {
    let data = { connection: "horizon" };
    return this.api.http_fibercloud
      .post("v1/imports/" + uuid + "/cancel", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getTemplatesTypes(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/importDataMapper/templateType")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createImportTemplate(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/imports/importDataMapper/template", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  editImportTemplate(id, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/imports/importDataMapper/template/" + id, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getKeysFromFile(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/imports/importDataMapper", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}

export default Import;



// WEBPACK FOOTER //
// ./src/api/import.js